import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export default function InstallAppButton() {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { setInstalled(true); setPrompt(null); toast.success("Medical CDSS installed"); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || (!prompt && !isIOS())) return null;

  const install = async () => {
    if (!prompt) {
      toast.info("To install: tap the Share icon in Safari, then choose \"Add to Home Screen\".", { duration: 8000 });
      return;
    }
    prompt.prompt();
    await prompt.userChoice;
    setPrompt(null);
  };

  return (
    <Button variant="outline" size="sm" onClick={install} data-testid="install-app-btn" className="border-zinc-300">
      <Download className="h-4 w-4 sm:mr-2" /> <span className="hidden sm:inline">Install app</span>
    </Button>
  );
}
